// Design tokens for the Hub navigation shell.
// Values come verbatim from the Claude Design handoff (design_handoff_hub_navigation).
// Colors that also live in the MUI theme (primary #00b6e0, brandYellow #ffce1a,
// error #EE3943) are duplicated here as literals so the rail — which paints on the
// dark Ebony Clay surface — is self-contained and does not depend on theme lookups.

export const RAIL_WIDTH = 262;
export const RAIL_WIDTH_COLLAPSED = 72;
export const APPBAR_HEIGHT = 58;

// Breakpoint mirrors the legacy header (react-bootstrap `expand="lg"` = 992px).
export const DESKTOP_QUERY = '(min-width:992px)';
// Above this the rail defaults to expanded; between 992–1199 it defaults collapsed.
export const WIDE_QUERY = '(min-width:1200px)';

export const RAIL_TRANSITION = 'width 200ms cubic-bezier(.2,0,0,1)';

export const C = {
  ink: '#262C37', // Ebony Clay — rail, footer, toast, primary text
  inkHover: '#171b23',
  turquoise: '#00B6E0', // primary — active state, focus, avatar
  turquoiseText: '#00708c',
  turquoiseCheck: '#00607a',
  turquoiseTint: '#E7F7FA',
  yellow: '#FFCE1A',
  yellowText: '#7a5d00',
  yellowTint: '#FFF6DC',
  error: '#EE3943',

  // Rail-on-dark text ramp
  railText: '#d6dae1',
  railIcon: '#9aa1ad',
  railSubheader: '#78808f',
  railLeaf: '#aeb5c1',
  railLeafActive: '#fff',
  railBorder: 'rgba(255,255,255,.09)',
  railActiveBg: 'rgba(0,182,224,.16)',
  railLeafActiveBg: 'rgba(255,255,255,.09)',

  // Stats panel surfaces (design_handoff_membership_stats, sc-15188)
  periodBg: '#FBFCFD', // Group whose indicators depend on a date range
  pressed: '#EDEFF3', // Indicator held down, over a white surface
  pressedOnPeriod: '#EAEDF1', // Same, over periodBg
  errorTint: '#FDF0F1', // Inline error band, paired with `error` as its border

  // Light surfaces / borders / text
  page: '#F6F7F9',
  surface: '#fff',
  border: '#E3E6EB',
  borderSoft: '#F0F1F4',
  text: '#262C37',
  textMid: '#3d4453',
  textMuted: '#6B7380',
  textFaint: '#9aa1ad',
};

export const SHADOW = {
  focusRing: '0 0 0 3px rgba(0,182,224,.18)',
  focusRingStrong: '0 0 0 3px rgba(0,182,224,.30)',
  popover: '0 16px 40px rgba(38,44,55,.22)',
  palette: '0 30px 70px rgba(38,44,55,.35)',
  toast: '0 14px 34px rgba(38,44,55,.30)',
};

export const FONT = "Montserrat, system-ui, sans-serif";
